import React from "react";

import SelectDropdown from "src/app/components/SelectDropdown/SelectDropdown";
import useGlobalCreatorDropdownData from "src/app/dropdowns/GlobalCreatorDropdown/hooks/useGlobalCreatorDropdownData";

interface GlobalCreatorDropdownProps {
  fieldValue: string[] | null;
  handleUpdateValue: (values: string[]) => void;
  isOpen: boolean;
}

export default function GlobalCreatorDropdown({
  fieldValue,
  handleUpdateValue,
  isOpen,
}: GlobalCreatorDropdownProps) {
  const [
    handleSelectOption,
    handleUnselectOption,
    handleUserQuery,
    selectedOptions,
    options,
    isLoading,
  ] = useGlobalCreatorDropdownData({
    fieldValue,
    handleUpdateValue,
  });

  return (
    <div className="select__wrapper">
      <SelectDropdown
        options={options}
        selectedOptions={selectedOptions}
        handleUserQuery={handleUserQuery}
        handleUnselectOption={handleUnselectOption}
        handleSelectOption={handleSelectOption}
        isOpen={isOpen}
        isLoading={isLoading}
        inputPlaceholder={{
          id: "ws_search_global_creator",
          defaultMessage: "Type to find a global creator",
        }}
      />
    </div>
  );
}
